<div *ngIf="!isLoading">

    <div style="margin-bottom: 5px;">
        <img src="../../assets/img/Schedule.jpg" alt="Banner"
            style="width: 100%; display: block; margin: 0; padding: 0;">
    </div>
    <div class="top-bar">
        <div class="top-bar-item">
            <gux-icon size="large" icon-name="toolbar-phone-active-3" decorative="true"></gux-icon>
            Call Status: {{callStatus}}
        </div>
        <gux-tag emphasis="bold" accent="inherit" size="large" class="other-color"
            *ngIf="dispositionTimer">
            Disposition Countdown: {{autoDispositionLimit! - dispositionTimer!}}
        </gux-tag>

        <div class="top-bar-item">
            Call Type: {{callType}}
        </div>
    </div>
    <hr>

    <app-student-info-block [studentData]="studentData" [displayReferredBy]=true [displayOtherInfo]=displayOtherInfo
        [otherInfoMsg]="otherInfoMsg" [showStudentId]=false></app-student-info-block>

    <hr>

    <span style="font-size: 14px; font-weight: bold;">Interview</span>

    <div class="interview-radio-container">
        <span style="width: 100px;">Engaged</span>
        <input type="radio" id="yes" name="consent" [value]="true" [(ngModel)]="isEngaged" (change)="checkIsSelected()">
        <label for="yes">Yes</label>
        <input type="radio" id="no" name="consent" [value]="false" [(ngModel)]="isEngaged" (change)="checkIsSelected()">
        <label for="no">No</label>
    </div>



    <div class="schedule-result-and-date-picker-container">
        <div class="schedule-result-and-date-picker-item">
            <span *ngIf="isEngaged === true && dropdownChoice === null"
                style="font-size: 14px; color: red;">Result*</span>
            <span *ngIf="!(isEngaged === true && dropdownChoice === null)" style="font-size: 14px;">Result</span>
            <div class="schedule-dropdown-container">
                <gux-dropdown placeholder="-- Please Select --" [disabled]="!isEngaged" [attr.value]="dropdownChoice">
                    <gux-listbox aria-label="Result">
                        <ng-container *ngFor="let event of CNexusEvents">
                            <gux-option [value]="event" *ngIf="isEngaged" (click)="dropdownSelected(event)"
                                (keypress)="dropdownSelected(event)" (keydown)="dropdownSelected(event)"
                                (keyup)="dropdownSelected(event)">
                                {{event?.description}}
                            </gux-option>
                        </ng-container>
                    </gux-listbox>
                </gux-dropdown>
            </div>
        </div>

        <div class="schedule-result-and-date-picker-item" [hidden]="!isEngaged">
            <span *ngIf="isDateError" style="font-size: 14px; color: red;">The selected date cannot be in the
                past.</span>
            <span style="font-size: 14px;">Select a Date and Time</span>
            <div class="schedule-date-picker-container">
                <gux-datepicker [value]="scheduleDate" format="mm/dd/yyyy" [minDate]="minDate" (input)="scheduleDateChanged($event)"></gux-datepicker>
                <gux-time-picker id="timePicker" clock-type="12h" interval="15" [value]="scheduleTime" (input)="scheduleTimeChanged($event)" ></gux-time-picker>
            </div>
        </div>
    </div>

    <gux-form-field-textarea label-position="above" style="margin-top: 20px;">
        <textarea slot="input" name="textarea" class="schedule-notes-box" id="notes" [disabled]="!isEngaged"
            [(ngModel)]="comments"></textarea>
        <label *ngIf="isEngaged === true && comments.length == 0" slot="label" for="notes"><span
                style="color: red;">Notes*</span></label>
        <label *ngIf="!(isEngaged === true && comments.length == 0)" slot="label" for="notes">Notes</label>
    </gux-form-field-textarea>


    <div class="button-container">
        <gux-button id="submitschedule" accent="{{buttonType}}" class="call-button" (click)="submit()" (keypress)="submit()"
            [disabled]="(isEngaged === undefined || (isEngaged === true && (dropdownChoice === null || comments.length == 0)))">
            <span>Submit</span>
        </gux-button>

        <gux-button accent="danger" class="call-button" (click)="cancel()" (keypress)="cancel()">
            <span>Cancel</span>
        </gux-button>
    </div>
</div>